<template>
  <div class="shop-conditions-tree" :class="{ 'shop-conditions-tree--selected': isSelected }">
    <button type="button" class="shop-conditions-tree__element" @click="select">
      <span class="shop-conditions-tree__level" :style="`--indent: ${level - 1}`"></span>
      <FontAwesomeIcon :icon="['fal', isExpanded ? 'minus' : 'plus']" size="sm" :data-hidden="!items.length" />
      <span>{{ label }}</span>
    </button>

    <div v-show="isExpanded">
      <Tree
        v-for="item in items"
        :value="value"
        :item="item"
        :key="item.id"
        :level="level + 1"
        v-on="{
          ...$listeners,
          expand: expand,
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tree',
  props: {
    value: Array,
    item: Object,
    level: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    isSelected: {
      handler(val) {
        if (!val) return

        this.expand()
      },
      immediate: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    }
  },
  computed: {
    items() {
      return this.item.categories || this.item.items || []
    },
    label() {
      if ('product' in this.item) return this.item.product.name
      return this.item.label
    },
    isSelected() {
      if (!this.value) return false
      return this.value.includes(this.item.id)
    },
    isSelectable() {
      return 'product' in this.item
    },
  },
  methods: {
    toggle() {
      if (this.isExpanded) this.isExpanded = false
      else this.expand()
    },
    expand() {
      this.isExpanded = true
      this.$emit('expand')
    },
    select() {
      this.toggle()

      if (!this.isSelectable) return
      if (this.isSelected)
        this.$emit(
          'input',
          this.value.filter(v => v !== this.item.id),
        )
      else this.$emit('input', [...this.value, this.item.id])
    },
  },
  components: {},
}
</script>

<style lang="scss">
.shop-conditions-tree {
  &__level {
    display: inline-block;
    padding-right: calc(var(--indent) * 1rem);
  }

  &__element {
    width: 100%;
    text-align: left;
    display: block;
    cursor: pointer;
    padding: 1rem;
    transition: background-color 150ms ease, border-color 150ms ease;
    border: 1px solid transparent;
    border-top-color: var(--border-color);

    &:hover {
      background-color: css-alpha('border-color', 0.2);
    }

    .shop-conditions-tree--selected > & {
      background-color: css-alpha('primary', 0.05) !important;
      color: css-darken('primary', 15%);
    }
  }

  svg {
    margin-right: 0.75rem;
    opacity: 0.3;

    &[data-hidden='true'] {
      opacity: 0;
    }
  }
}
</style>
